/*
 *
 *  Main Store
 */

// deps
import Vue from 'vue'
import Vuex from 'vuex'

// uis
import ui from '@/store/modules/s.ui'
import guide from '@/store/modules/s.ui.guide'
import snackbar from '@/store/modules/s.ui.snackbar'

// data
import services from '@/store/modules/s.services'

// use
Vue.use(Vuex)

// store
const store = new Vuex.Store({
  modules: {
    ui,
    guide,
    snackbar,
    services
  }
})

// export
export default store
